import { useEffect } from 'react'

const useOrientationChange = (imgPopupOpened: string) => {
  useEffect(() => {
    if (imgPopupOpened) return

    const openedImage = document.querySelector('.img_opened')
    if (openedImage) {
      openedImage.classList.remove('img_opened')
      window.scrollTo(0, (openedImage as HTMLElement).offsetTop)
    }
  }, [imgPopupOpened])
}

export default useOrientationChange
